/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type OutputActions_output$ref: FragmentReference;
declare export opaque type OutputActions_output$fragmentType: OutputActions_output$ref;
export type OutputActions_output = {|
  +id: string,
  +$refType: OutputActions_output$ref,
|};
export type OutputActions_output$data = OutputActions_output;
export type OutputActions_output$key = {
  +$data?: OutputActions_output$data,
  +$fragmentRefs: OutputActions_output$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OutputActions_output",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "TacticalOutput",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'b4d3667412d951ca35736110b74c44c7';

module.exports = node;
